import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=00a3712c&scoped=true"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3712c",
  null
  
)

export default component.exports